var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDustbin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: ".75vw",
    height: ".8vw",
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.79195 3.92865H1.70805C1.317 3.92865 1 4.24832 1 4.64264V10.3572C1 11.5406 1.95139 12.5 3.125 12.5H7.375C7.93859 12.5 8.47909 12.2742 8.8776 11.8724C9.27612 11.4705 9.5 10.9255 9.5 10.3572V4.64264C9.5 4.24832 9.183 3.92865 8.79195 3.92865Z",
    stroke: "#F23D3D",
    strokeOpacity: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8002 2.21434L7.7101 2.03349C7.24421 1.09368 6.29171 0.5 5.24977 0.5C4.20783 0.5 3.25533 1.09368 2.78945 2.03349L2.7002 2.21434H7.8002Z",
    stroke: "#F23D3D",
    strokeOpacity: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33306 6.78549C4.33306 6.50935 4.10921 6.28549 3.83306 6.28549C3.55692 6.28549 3.33306 6.50935 3.33306 6.78549H4.33306ZM3.33306 9.64232C3.33306 9.91846 3.55692 10.1423 3.83306 10.1423C4.10921 10.1423 4.33306 9.91846 4.33306 9.64232H3.33306ZM7.16694 6.78549C7.16694 6.50935 6.94309 6.28549 6.66694 6.28549C6.3908 6.28549 6.16694 6.50935 6.16694 6.78549H7.16694ZM6.16694 9.64232C6.16694 9.91846 6.3908 10.1423 6.66694 10.1423C6.94309 10.1423 7.16694 9.91846 7.16694 9.64232H6.16694ZM7.79998 1.71439C7.52384 1.71439 7.29998 1.93824 7.29998 2.21439C7.29998 2.49053 7.52384 2.71439 7.79998 2.71439V1.71439ZM9.49998 2.71439C9.77612 2.71439 9.99998 2.49053 9.99998 2.21439C9.99998 1.93824 9.77612 1.71439 9.49998 1.71439V2.71439ZM2.7 2.71439C2.97614 2.71439 3.2 2.49053 3.2 2.21439C3.2 1.93824 2.97614 1.71439 2.7 1.71439V2.71439ZM1 1.71439C0.723858 1.71439 0.5 1.93824 0.5 2.21439C0.5 2.49053 0.723858 2.71439 1 2.71439V1.71439ZM3.33306 6.78549V9.64232H4.33306V6.78549H3.33306ZM6.16694 6.78549V9.64232H7.16694V6.78549H6.16694ZM7.79998 2.71439H9.49998V1.71439H7.79998V2.71439ZM2.7 1.71439H1V2.71439H2.7V1.71439Z",
    fill: "#F23D3D",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDustbin);
export default __webpack_public_path__ + "static/media/dustbin.569a2f5c64f9752f7fc13e6ac932487b.svg";
export { ForwardRef as ReactComponent };